import ModelMappingOrigin from "~/models/mapping/modelMappingOrigin";
import {ModelMappingOriginSFKlasses} from "~/models/mapping/modelMappingOriginFactory";

export let SalesforceInstanceHelper = {
  modelMappingOriginIsSalesforce: function <T extends ModelMappingOrigin>(modelMappingOrigin: T): boolean {
    return ModelMappingOriginSFKlasses.some(klass => {
      return modelMappingOrigin instanceof klass
    })
  },
}
